import React from "react";
import Navigation from '../components/Navigation';



const Autre = () => {
    return(
        <div>
            <Navigation/>
            
        </div>
    )
}

export default Autre